import React, { useState, useEffect } from 'react'
import { Heart } from 'lucide-react'
import { motion, AnimatePresence } from 'framer-motion'

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear()
  
  // Состояние для пасхалки
  const [clickCount, setClickCount] = useState(0)
  const [isLongPress, setIsLongPress] = useState(false)
  const [showEasterEgg, setShowEasterEgg] = useState(false)
  const [longPressTimer, setLongPressTimer] = useState<number | null>(null)
  
  // Обработчик клика по сердечку
  const handleHeartClick = () => {
    setClickCount(prev => prev + 1)
  }
  
  // Обработчик начала долгого нажатия
  const handleHeartMouseDown = () => {
    if (clickCount >= 20) {
      const timer = window.setTimeout(() => {
        setIsLongPress(true)
        setShowEasterEgg(true)
      }, 1000) // 1 секунда задержки
      setLongPressTimer(timer)
    }
  }
  
  // Обработчик окончания долгого нажатия
  const handleHeartMouseUp = () => {
    if (longPressTimer) {
      window.clearTimeout(longPressTimer)
      setLongPressTimer(null)
    }
    setIsLongPress(false)
  }
  
  // Обработчик ухода мыши
  const handleHeartMouseLeave = () => {
    if (longPressTimer) {
      window.clearTimeout(longPressTimer)
      setLongPressTimer(null)
    }
    setIsLongPress(false)
  }
  
  // Закрытие модального окна
  const closeEasterEgg = () => {
    setShowEasterEgg(false)
    setClickCount(0)
  }
  
  // Очистка таймера при размонтировании
  useEffect(() => {
    return () => {
      if (longPressTimer) {
        window.clearTimeout(longPressTimer)
      }
    }
  }, [longPressTimer])




  return (
    <footer className="">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        {/* Main Footer Content */}
        <div className="">
          {/* Brand Section */}
          <div className="">
            <div className="">
              <div className="">
              </div>
              <span className="">

              </span>
            </div>


          </div>

          {/* Family Links */}
          <div>
          </div>

          {/* Community Links */}
          <div>
          </div>

          {/* Resources Links */}
          <div>

          </div>
        </div>



        {/* Bottom Bar */}
        <div className="pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © {currentYear} Hugo Family. All rights reserved.
            </div>
            <div className="flex items-center space-x-4 text-sm text-gray-400">
              <a href="#" className="hover:text-white transition-colors">

              </a>
              <span></span>
              <a href="#" className="hover:text-white transition-colors">

              </a>
              <span></span>
              <a href="#" className="hover:text-white transition-colors">

              </a>
            </div>
            <div className="flex items-center space-x-2 text-gray-400 text-sm">
              <span>Made with</span>
              <Heart 
                className={`w-4 h-4 text-red-400 cursor-pointer transition-all duration-200 ${
                  isLongPress ? 'scale-125 animate-pulse' : 
                  clickCount > 0 ? 'scale-110' : ''
                }`}
                onClick={handleHeartClick}
                onMouseDown={handleHeartMouseDown}
                onMouseUp={handleHeartMouseUp}
                onMouseLeave={handleHeartMouseLeave}
              />
              <span>for the HUGO Family</span>
            </div>
          </div>
        </div>
      </div>
      
      {/* Модальное окно пасхалки */}
      <AnimatePresence>
        {showEasterEgg && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 z-[10005] backdrop-blur-md bg-black/80 flex items-center justify-center p-4"
            onClick={closeEasterEgg}
          >
            <motion.div
              initial={{ scale: 0.8, opacity: 0 }}
              animate={{ scale: 1, opacity: 1 }}
              exit={{ scale: 0.8, opacity: 0 }}
              transition={{ type: "spring", damping: 25, stiffness: 300 }}
              className="bg-gradient-to-br from-purple-600/90 to-blue-600/90 backdrop-blur-xl rounded-3xl border border-white/20 p-8 text-center max-w-md w-full"
              onClick={(e) => e.stopPropagation()}
            >
              {/* HUGO с короной */}
              <motion.div
                initial={{ y: -20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.2 }}
                className="mb-6"
              >
                <div className="text-6xl mb-2">👑</div>
                <h2 className="text-3xl font-bold text-white mb-2">HUGO</h2>

              </motion.div>
              
              {/* HARDY с мусором */}
              <motion.div
                initial={{ y: 20, opacity: 0 }}
                animate={{ y: 0, opacity: 1 }}
                transition={{ delay: 0.4 }}
                className="mb-6"
              >
                <div className="text-6xl mb-2">🗑️</div>
                <h2 className="text-3xl font-bold text-white mb-2">HARDY</h2>
              </motion.div>
              
              {/* Кнопка закрытия */}
              <motion.button
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 0.6 }}
                onClick={closeEasterEgg}
                className="bg-white/20 hover:bg-white/30 backdrop-blur-sm px-6 py-3 rounded-xl text-white font-semibold transition-all duration-200 border border-white/30"
              >
                Закрыть
              </motion.button>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </footer>
  )
}

export default Footer 